import { render } from "./Home.vue?vue&type=template&id=953c361e"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=953c361e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__